"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeConfigs = exports.saturationAdjustmentFn = exports.hueRotationFn = void 0;

function hueRotationFn(rotation) {
  return function (hue) {
    return (360 + hue + rotation) % 360;
  };
}

exports.hueRotationFn = hueRotationFn;

function saturationAdjustmentFn(adjustment) {
  return function (saturation) {
    return Math.min(Math.max(saturation + adjustment, 0), 100);
  };
}

exports.saturationAdjustmentFn = saturationAdjustmentFn;

function mergeConfigs(base, extended) {
  return Object.entries(base).reduce(function (accumulator, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        role = _ref2[0],
        variants = _ref2[1];

    var extendedVariants = extended[role];

    var mergedVariants = _toConsumableArray(variants);

    if (extendedVariants != null) {
      extendedVariants.forEach(function (variant) {
        var name = variant.name;
        var indexToReplace = mergedVariants.findIndex(function (baseVariant) {
          return baseVariant.name === name;
        });

        if (indexToReplace === -1) {
          mergedVariants.push(variant);
        } else {
          mergedVariants.splice(indexToReplace, 1, variant);
        }
      });
    }

    return Object.assign(Object.assign({}, accumulator), _defineProperty({}, role, mergedVariants));
  }, {});
}

exports.mergeConfigs = mergeConfigs;